import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import BreadCrumb from "../BreadCrumb";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";

import { Link, useLocation } from "react-router-dom";

import two from "../../assets/images/resource/man.png";

import service from "../../assets/images/resource/DET.jpg";
import { Helmet } from "react-helmet-async";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/DataEngi-new.png";

const DataEngineering = () => {
  pageTitle("Cloudera Data Engineering Course");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const servicesData = [
    { id: 1, title: "AI & RPA", slug: "/rpa-training" },
    { id: 2, title: "Python & SQL", slug: "/python" },
    { id: 3, title: "Data Science With Python", slug: "/cloud" },
    {
      id: 4,
      title: "Cloudera Data Engineering",
      slug: "/data-engineering-course",
    },
    { id: 5, title: "Cloudera Machine Learning", slug: "/machine-learning" },
    { id: 6, title: "Cloudera AI", slug: "/AI" },
    { id: 7, title: "Cloudera Data analyst", slug: "/data-analyst" },
  ];
  const courseDetails = [
    {
      number: 1,
      title: "Developing Applications with Apache Spark",
      topics: "Explore how to develop scalable and efficient applications using Apache Spark for big data processing. Learn to handle massive datasets with speed, resilience, and scalability.",
      youtubeShort: "https://youtu.be/0Xj9HRMOmX0?si=L3N0tanNUGIQBcPs"
    },
    {
      number: 2,
      title: "Introduction to Apache Hadoop & Hadoop Ecosystem",
      topics: "Get introduced to Apache Hadoop and its powerful ecosystem designed for scalable and distributed data processing. Learn how Hadoop handles massive datasets efficiently and lays the groundwork for modern big data solutions.",
      youtubeShort: "https://youtu.be/vGlK7BOBwB4?si=4fBKwBabVQ2RiT5g"
    },
    {
      number: 3,
      title: "Apache Hadoop File Storage – HDFS Explained",
      topics: "Dive deep into Hadoop Distributed File System (HDFS) – the foundation of Apache Hadoop's storage architecture. Learn how HDFS efficiently manages big data storage across distributed clusters while ensuring fault tolerance and high availability.",
      youtubeShort: "https://youtu.be/y-PYqTDWrqM?si=sWZhONE0FPp4Tg_X"
    },
    {
      number: 4,
      title: "Distributed Processing on an Apache Hadoop Cluster",
      topics: "Learn how Apache Hadoop clusters enable high-performance distributed processing of massive datasets. Understand how multiple nodes work together to store, process, and analyze big data efficiently using MapReduce and YARN.",
      youtubeShort: "https://youtu.be/IZzTCKwTAUw?si=rUxm_09V0TQZmKep"
    },
    {
      number: 5,
      title: "Apache Spark Basics",
      topics: "Get introduced to Apache Spark, the powerful big data processing framework designed for speed and scalability. Understand its core concepts, architecture, and components to process massive datasets efficiently.",
      youtubeShort: "https://youtu.be/t2Eso5ZP3bM?si=vLoj8wKHIuutxkds"
    },
    {
      number: 6,
      title: "Working with DataFrames & Schemas in Apache Spark",
      topics: "Learn how to use Spark DataFrames & Schemas to efficiently manage structured and semi-structured data. Understand how schema definition improves performance and enables better data organization for big data analytics.",
      youtubeShort: "https://youtu.be/q9loNQSgbPs?si=AlEObRdJ7OxoUh9S"
    },
    {
      number: 7,
      title: "Analyzing Data with Spark DataFrames",
      topics: "Dive deep into data analysis using Spark DataFrames. Learn how to manipulate, filter, aggregate, and visualize large datasets efficiently with Spark SQL and built-in functions to drive meaningful insights.",
      youtubeShort: "https://youtu.be/-vK1SntRpXo?si=62_BeD9G1xgzkUAa"
    },
    {
      number: 8,
      title: "Mastering RDDs in Apache Spark",
      topics: "Master RDDs, the fundamental data structure of Apache Spark. Learn how to efficiently process large-scale distributed data using transformations, actions, and persistence techniques for high-performance computing.",
      youtubeShort: "https://youtu.be/Qkc1Qqidvk0?si=Q3RsPAoQmW7_nAwR"
    },
    {
      number: 9,
      title: "Transforming Data with Paired RDDs & Apache Spark",
      topics: "Explore how Paired RDDs enable powerful key-value transformations in Apache Spark. Learn how to process structured data, optimize computations, and perform aggregations, joins, and grouping efficiently.",
      youtubeShort: "https://youtu.be/_WwnxJOobq4?si=c7LdhyDSno3IXtWs"
    },
    {
      number: 10,
      title: "Aggregating Data with Paired RDDs in Apache Spark",
      topics: "Dive into Paired RDD Aggregations to efficiently process and summarize large datasets. Learn how to use reduceByKey, aggregateByKey, and combineByKey to perform powerful data aggregation and analysis in a distributed environment.",
      youtubeShort: "https://youtu.be/2BgO2ngW5j4?si=P0L1W-ThKgvRk2j6"
    },
    {
      number: 11,
      title: "Querying Tables and Views with SQL",
      topics: "Learn how to query structured data in Apache Spark using SQL. Discover how to work with tables and views, optimize queries, and retrieve data efficiently for big data analytics.",
      youtubeShort: "https://youtu.be/DReYGovaKEM?si=NJ8pv8eHouGZqKZn"
    },
    {
      number: 12,
      title: "Spark Shell vs Spark Application",
      topics: "Dive into the key differences between Spark Shell and Spark Applications. Learn when to use interactive mode for quick testing and when to deploy a full-fledged application for big data processing.",
      youtubeShort: "https://youtu.be/nxfgVXpMizE?si=jvRgU1fxuBfE76Z5"
    },
    {
      number: 13,
      title: "Spark Distributed Processing",
      topics: "Learn how Apache Spark efficiently processes massive datasets across multiple nodes. Understand the distributed execution model, how Spark handles parallel processing, and optimizes performance for big data workloads.",
      youtubeShort: "https://youtu.be/3ci_k7qTKdg?si=5OcwwmWG_bH4lDib"
    },
    {
      number: 14,
      title: "Distributed Data Persistence in Apache Spark",
      topics: "Explore how Apache Spark handles distributed data persistence to optimize performance and fault tolerance. Understand different storage levels, caching mechanisms, and checkpointing techniques to enhance efficiency in large-scale data processing.",
      youtubeShort: "https://youtu.be/qz2Mu6Jlv4A?si=Xggz7-d_p7Ao8hII"
    },
    {
      number: 15,
      title: "Introduction to Apache Hive – The SQL Layer of Hadoop",
      topics: "Explore Apache Hive, the powerful SQL-based data warehouse built on Hadoop. Learn how Hive simplifies querying big data, making it accessible to data analysts and engineers using familiar SQL syntax.",
      youtubeShort: "https://youtu.be/1ELI4ZQESoY?si=J0iZqktoywkiw1Gm"
    },
    {
      number: 16,
      title: "Transforming Data with Apache Hive",
      topics: "Learn how to transform and process big data using HiveQL. Discover how Hive simplifies data manipulation, aggregation, and optimization for large datasets stored in Hadoop.",
      youtubeShort: "https://youtu.be/dRZs62Gmlmk?si=f7ysNIHfKqHRXv-l"
    },
    {
      number: 17,
      title: "Hive Joins & Advanced Features",
      topics: "Dive deep into advanced Hive functionalities, including joins, subqueries, partitions, and bucketing. Learn how to efficiently combine and process large datasets stored in Hadoop using HiveQL.",
      youtubeShort: "https://youtu.be/9B9bqQFBk6E?si=9O0OUBKLxEgnZW5F"
    },
    {
      number: 18,
      title: "Mastering Hive Partitioning & Data Engineering",
      topics: "Learn how Hive Partitioning enhances query performance by efficiently organizing large datasets. Understand data engineering best practices for handling structured and semi-structured data using Apache Hive.",
      youtubeShort: "https://youtu.be/8R4WklW_s3k?si=SE8WTpIRQ0uYImNO"
    },
    {
      number: 19,
      title: "Mastering Hive Partitioning, Buckets & Complex Data",
      topics: "Dive deeper into Hive Partitioning, Bucketing, and Complex Data Handling. Learn how these techniques help organize, manage, and optimize large datasets for faster queries and efficient data processing.",
      youtubeShort: "https://youtu.be/EJMisxCN0yw?si=X7hiV-BJVDqHvSUl"
    },
    {
      number: 20,
      title: "Hive & Spark Integration",
      topics: "Learn how to integrate Apache Hive with Apache Spark for fast and scalable data processing. Understand how Spark interacts with Hive tables, queries, and metadata, enabling advanced ETL and analytics workflows.",
      youtubeShort: "https://youtu.be/Q5nGhbD97hI?si=iRfbTIIF9i6g2opd"
    }
  ];


  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/Data-engineering-course" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };
  const getYouTubeVideoId = (url) => {
    const parts = url.split("/");
    let id = parts[parts.length - 1];
    // Remove query parameters if present
    if (id.includes("?")) {
      id = id.split("?")[0];
    }
    return id;
  };
  const featuredYoutubeLink = "https://youtu.be/Spw2va7f6m8?si=xBEYfUesNKdanuG4";
  const featuredVideoId = getYouTubeVideoId(featuredYoutubeLink);
  const featuredEmbedUrl = `https://www.youtube.com/embed/${featuredVideoId}`;

  return (
    <>
      <Helmet>
        <title>Cloudera Data Engineering Course - Learn Apache Spark</title>
        <meta
          name="description"
          content="Join our Cloudera Data Engineering Course to master Apache Spark, DataFrames, and Hive on the Cloudera Data Platform. Enroll now for hands-on training!"
        />
        <meta
          name="keywords"
          content="Cloudera, Data Engineering, Apache Spark, DataFrames, Hive, Big Data, Data Pipelines"
        />
        <meta name="author" content="SIW" />
      </Helmet>
      <HeaderOne />

      <section className="page__title p_relative ">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${g1})` }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative">
            {/* <ul className="bread__crumb">
                    <li><Link to="/">Home</Link></li>
                    {pathnames.map((name, index) => (
                    <li key={index}>
                        <span> -</span>
                        <Link to={`/${pathnames.slice(0, index + 1).join('/')}`}>{name}</Link>
                    </li>
                    ))}
                </ul> */}
            {/* <h1 className="title">{pathnames.length > 0 ? pathnames[pathnames.length - 1] : 'Home'}</h1> */}
          </div>
        </div>
      </section>

      <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12">
              <div className="service__right">
                <figure>
                  <img src={service} alt="Service" />
                </figure>

                <h2>
                  <span>Cloudera Data Engineering Course Overview</span>
                </h2>

                <p>
                  This four-day hands-on training course delivers the key
                  concepts and knowledge developers need to utilize Apache Spark
                  for high-performance, parallel applications on the Cloudera
                  Data Platform (CDP). By focusing on Cloudera Data Engineering,
                  participants will gain valuable skills in managing data and
                  building robust data pipelines.
                </p>

                <h3>
                  <span>What You’ll Learn</span>
                </h3>

                <ul style={{ marginBottom: "15px", lineHeight: "1.0" }}>
                  <li>Distribute, store, and process data in a CDP cluster.</li>
                  <li>Write, configure, and deploy Apache Spark applications.</li>
                  <li>Use Spark interpreters and applications to explore, process, and analyze distributed data.</li>
                  <li>Query data using Spark SQL, DataFrames, and Hive tables.</li>
                  <li>Deploy a Spark application on the Data Engineering Service.</li>
                </ul>

                <h3>
                  <span>What to Expect</span>
                </h3>

                <p>
                  This course is designed for developers and data engineers.
                  Students should have basic Linux experience, and basic
                  proficiency in either Python or Scala programming. Basic
                  knowledge of SQL is helpful, but prior knowledge of Spark and
                  Hadoop is not required.
                </p>


                <h3>
                  <span>Course Details</span>
                </h3>
                <ul className="course-details-list" style={{ listStyle: "none", padding: 0 }} >
                  {courseDetails.map((item) => {
                    const videoId = getYouTubeVideoId(item.youtubeShort);
                    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                    return (
                      <li
                        key={item.number}
                        className="course-detail-item"
                        style={{
                          display: "flex",
                          alignItems: "start",
                          marginBottom: "20px",
                          background: "#f9f9f9",
                          padding: "15px",
                          borderRadius: "8px",
                        }}
                      >
                        <div style={{ flex: 1, paddingRight: "30px" }}>
                          <h5 style={{ margin: "0 0 10px", fontWeight: "bold" }}>
                            {item.number}. {item.title}
                          </h5>
                          <p style={{ margin: 0 }}>{item.topics}</p>
                        </div>
                        <div
                          className="course-detail-video"
                          style={{ position: "relative", minWidth: "120px", marginLeft: "20px" }}
                        >
                          <a
                            href={item.youtubeShort}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: "block", position: "relative" }}
                          >
                            <img
                              src={thumbnailUrl}
                              alt={`Youtube Short for ${item.title}`}
                              style={{ width: "150px", height: "auto", borderRadius: "4px" }}
                            />
                            <div
                              className="play-button"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2,
                              }}
                            >
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <polygon points="12,8 24,16 12,24" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>

                {/* <form onSubmit={handleSubmit} className="contact__form">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    required
                  />

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    required
                  />

                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    required
                  />

                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone"
                    required
                  />

                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message"
                    required
                  />

                  <button type="submit" className="theme-btn">
                    Submit
                  </button>
                </form> */}
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="service__details__left">
              {/* <div
                  className="sidebar__widget_network"
                  style={{ backgroundImage: `url(${basebg})`,margin:'0' }}
                > */}
              <iframe
                      width="100%"
                      height="600"
                      src={featuredEmbedUrl}
                      title="Featured YouTube Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ borderRadius: "8px" }}
                    ></iframe>
                    {/* </div> */}
                <div className="sidebar__widget">
                  <div className="all__service mt-50">
                    <h4>All Courses</h4>
                  </div>
                  <ul className="service__details__1__cat">{renderServices()}</ul>
                </div>

                {/* Sidebar YouTube Thumbnail Widget */}

              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default DataEngineering;
